import { Vue } from 'vue-property-decorator';
import dayjs from 'dayjs';
import { authStore } from '@/stores';

Vue.filter('formatTime', (time, str = 'MMM DD, YYYY') => {
  if (!time) { return ''; }
  const m = dayjs(time).tz(authStore.timeZone);
  return m.isValid() ? m.format(str) : time;
});
